import { Outlet } from 'react-router-dom'
import Header from './Header'
import BottomNav from './BottomNav'

function MainLayout() {
  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col">
      {/* Header with navigation */}
      <Header />

      {/* Main content - full width without sidebar */}
      <main className="flex-1 pb-20 md:pb-0 overflow-y-auto">
        <Outlet />
      </main>

      {/* Bottom navigation (mobile) */}
      <BottomNav />
    </div>
  )
}

export default MainLayout
